'use strict';

export const COLOURS = {
  'swim':  '#0087D5',
  'bike':  '#DF0000',
  'run':   '#EE6100',
  'gym':   '#4DDC00',
  'total': '#000000',
  'other': '#9328E0',
  'intensity': {
    0: '#f1f1f1',
    1: '#53bdf8',
    2: '#bbeb8f',
    3: '#ffe57d',
    4: '#ffac52',
    5: '#ff6e6e',
    goal: 'rgba(192, 192, 192, 0.2)'
  }
}

export const hasBetaAccess = function (feature) {
  return xhale_meta_data.beta_access.indexOf(feature) > -1;
}

export var offlineModeIsActive = function () {
  let cookie_key = 'offline-mode-' + window.xhale_meta_data.user_id.toString();
  let cookie_value = getCookie(cookie_key);
  if (cookie_value == '1') {

    // Refresh the cookie duration.
    setCookie(cookie_key, 1, 180);

    return true;
  }
  else {
    return false;
  }
}

export var activateOfflineMode = function (user_id) {
  let cookie_key = 'offline-mode-' + user_id;
  setCookie(cookie_key, 1, 180);
}

export const clearOfflineData = function () {

  if (isWebStorageAvailable('localStorage')) {
    localStorage.clear();
  }

  const request = indexedDB.deleteDatabase('xhale');
  request.onerror = function (event) {
    // The error likely means that the user is in incognito mode.
    if (event.target.error.name == 'InvalidStateError') {
      event.preventDefault();
    }
  };

}

/**
 * Check if the Web Storage API is available in this browser.
 *
 * type: one of 'localStorage' or 'sessionStorage'
 */
function isWebStorageAvailable(type) {

  if (typeof window.xhale == 'undefined') {
    window.xhale = {
      global_state: {}
    }
  }

  if (typeof(window.xhale.global_state[type + '_available']) != 'boolean') {
    try {
      var storage = window[type], x = '__storage_test__';
      storage.setItem(x, x);
      storage.removeItem(x);
      window.xhale.global_state[type + '_available'] = true;
    }
    catch (e) {
      window.xhale.global_state[type + '_available'] = false;
    }
  }

  return window.xhale.global_state[type + '_available'];
}

/**
 * Shuffel an array.
 *
 * The array is passed by reference in JavaScript so does not return.
 * Copy it first to avoid mutating the original array.
 *
 * Implementation of the Durstenfeld shuffle, an optimized version of
 * Fisher-Yates.
 *
 * Taken from https://stackoverflow.com/a/12646864
 */
export const shuffleArray = function (array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
}

/**
 * Add an item to an array if it doesn't already exist otherwise remove it.
 *
 * @param {Array} array - The array we are operating on.
 * @param {various} item_to_toggle - The item to add or remove from the array.
 */
export const toggleInArray = function (array, item_to_toggle) {
  const index_in_array = array.indexOf(item_to_toggle);
  if (index_in_array == -1) {
    array.push(item_to_toggle);
  }
  else {
    array.splice(index_in_array, 1);
  }
  return array;
}

/**
 * Add an item to an array if it doesn't already exist.
 *
 * @param {Array} array - The array we are operating on.
 * @param {various} item_to_add - The item to add to the array.
 * @param {boolean} unshift - If set the item will be added to the start of the array.
 */
export const addToArrayIfNotExists = function (array, item_to_add, unshift) {
  var index_in_array = array.indexOf(item_to_add);
  if (index_in_array == -1) {
    if (unshift === true) {
      array.unshift(item_to_add);
    }
    else {
      array.push(item_to_add);
    }
  }
  return array;
}


/**
 * Remove an item from an array if it exists.
 *
 * @param {Array} array - The array we are operating on.
 * @param {various} item_to_remove - The item to remove from the array. Likely a string or integer.
 */
export const removeFromArrayIfExists = function (array, item_to_remove) {
  const index_in_array = array.indexOf(item_to_remove);
  if (index_in_array > -1) {
    array.splice(index_in_array, 1);
  }
  return array;
}

/*
 * Helper to get a cookie value.
 */
export const getCookie = function (key) {
  var nameEQ = key + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

/*
 * Helper to set a cookie.
 *
 * - key = the name of the cookie
 * - value = the value to store in the cookie.
 * - the number of days to store the cookie for. Leave blank to set a session
 *   cookie that will expire when the browser closes.
 */
export const setCookie = function (key, value, days) {
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    var expires = "; expires=" + date.toGMTString();
  }
  else {
    var expires = "";
  }
  document.cookie = key + "=" + value + expires + "; path=/";
}

/**
 * Produce a temporary id that is unique to this page load.
 */
export const getUniqueTemporaryID = function (key) {
  if (typeof(window.unique_temporary_id) == 'undefined') {
    window.unique_temporary_id = {};
  }
  if (!window.unique_temporary_id[key]) {
    unique_temporary_id[key] = 1;
  }
  return unique_temporary_id[key]++;
}

export function isObject(item) {
  return (item && typeof(item) === 'object' && !Array.isArray(item));
}

export function isArray(item) {
  return (item && typeof(item) === 'object' && Array.isArray(item));
}

export function objectsAreEquivalent(a, b) {

  // Compare dates.
  if (a instanceof Date && b instanceof Date) {
    return a.getTime() === b.getTime();
  }

  // Create arrays of property names
  var a_props = Object.getOwnPropertyNames(a);
  var b_props = Object.getOwnPropertyNames(b);

  // If number of properties is different,
  // objects are not equivalent
  if (a_props.length != b_props.length) {
    return false;
  }

  for (var i = 0; i < a_props.length; i++) {
    var prop_name = a_props[i];

    // If values of same property are not equal,
    // objects are not equivalent
    if (typeof(a[prop_name]) === 'object' && typeof(b[prop_name]) == 'object') {
      if (!objectsAreEquivalent(a[prop_name], b[prop_name])) {
        return false;
      }
    }
    else if (a[prop_name] !== b[prop_name]) {
      return false;
    }

  }

  // If we made it this far, objects
  // are considered equivalent
  return true;
}

export var objectAssignDeep = function (target, ...sources) {

  if (!sources.length) {
    return target;
  }

  const source = sources.shift();

  if (isObject(target) && isObject(source)) {

    for (const key in source) {

      if (isObject(source[key])) {

        if (!target[key]) {
          Object.assign(target, { [key]: {} });
        }

        objectAssignDeep(target[key], source[key]);
      }
      else {
        Object.assign(target, { [key]: source[key] });
      }

    }

  }
  else if (isArray(source) && isArray(target)) {
    for (let i = 0; i < source.length; i++) {
      target.push(source[i]);
    }
  }

  return objectAssignDeep(target, ...sources);
}

export const newDateFromDatestring = function (date_string) {
  // Takes dates in the format YYYY-MM-DD and converts them to an appropriate
  // date based on that string.
  var split_date = date_string.split('-');
  var year = split_date[0];
  var month = split_date[1] - 1;
  var day = split_date[2];
  return new Date(year, month, day)
}

export const newZuluDatetime = function (iso_datetime_string) {
  // Ensure it has a Zulu timezone.
  if (iso_datetime_string.slice(-1) != 'Z' && iso_datetime_string.slice(-6) != '+00:00') {
    iso_datetime_string += 'Z'
  }
  return new Date(iso_datetime_string);
}

/**
 * Format seconds as hours:minutes:seconds
 *
 * @param {(integer|float)} seconds - Number of seconds to format. This value will be rounded to the nearest integer.
 * @param {boolean} [show_hours_when_zero=false] - Given times under 1 hour should we show a zero for hours or nothing? (e.g. 00:59:00 or 59:00)
 * @param {boolean} [show_leading_zeros=false] - Given hours or minutes under 10 should we show an extra zero? (e.g. 05:01 or 5:01)
 * @param {boolean} [hide_seconds=false] - Should we show seconds?
 */
export const formatTime = function (seconds, show_hours_when_zero, show_leading_zeros, hide_seconds) {

  seconds = Math.round(seconds);
  var minutes = Math.floor(seconds / 60);
  var hours = Math.floor(minutes / 60);
  var remaining_minutes = minutes % 60;
  var remaining_seconds = seconds % 60;

  var time_string = '';

  if (hours > 0 || show_hours_when_zero) {
    if (show_leading_zeros) {
      time_string += (hours + 100).toString().slice(-2);
    }
    else {
      time_string += hours;
    }
    time_string += ':';
  }

  if (hours > 0 || show_hours_when_zero || show_leading_zeros) {
    time_string += (remaining_minutes + 100).toString().slice(-2);
  }
  else {
    time_string += remaining_minutes;
  }

  if (!hide_seconds) {
    time_string += ':' + (remaining_seconds + 100).toString().slice(-2);
  }

  return time_string;
}

export const getURLParameter = function (key) {
  var page_url = window.location.search.substring(1);
  var variables = page_url.split('&');
  for (var i = 0; i < variables.length; i++) {
    var parameter_name = variables[i].split('=');
    if (parameter_name[0] == key) {
      return parameter_name[1];
    }
  }
}

export var removeURLParameter = function (current_search_string, key) {
  var current_search_string = current_search_string.substring(1);
  var variables = (current_search_string.length > 0) ? current_search_string.split('&') : [] ;
  var new_url_parts = [];
  for (var i = 0; i < variables.length; i++) {
    var parameter = variables[i].split('=');
    if (parameter[0] != key) {
      new_url_parts.push(variables[i]);
    }
  }

  if (new_url_parts.length > 0) {
    var new_url = '?' + new_url_parts.join('&');
  }
  else {
    var new_url = '';
  }

  return new_url;
}

export const addOrAlterURLParameter = function (current_search_string, key, value) {
  var current_search_string = current_search_string.substring(1);
  var variables = (current_search_string.length > 0) ? current_search_string.split('&') : [] ;
  var new_url_parts = [];
  var key_set = false;
  for (var i = 0; i < variables.length; i++) {
    var parameter = variables[i].split('=');
    if (parameter[0] == key) {
      new_url_parts.push(key + '=' + value);
      key_set = true;
    }
    else {
      new_url_parts.push(variables[i]);
    }
  }

  if (!key_set) {
    new_url_parts.push(key + '=' + value);
  }

  if (new_url_parts.length > 0) {
    var new_url = '?' + new_url_parts.join('&');
  }
  else {
    var new_url = '';
  }

  return new_url;
}

export const zeroPad = function (integer, digits) {

  // Set default.
  if (isNaN(digits)) {
    digits = 2;
  }

  let integer_string = integer.toString();
  while (integer_string.length < digits) {
    integer_string = '0' + integer_string;
  }

  return integer_string;
}

export const secondsToHoursMinutesSeconds = function (seconds, return_as_zero_padded_strings, include_hours) {

  if (!seconds) {
    seconds = 0;
  }

  if (typeof(include_hours) == 'undefined') {
    include_hours == true;
  }

  var minutes = Math.floor(seconds / 60);
  var hours = Math.floor(minutes / 60);
  var remaining_minutes = minutes % 60;
  var remaining_seconds = seconds % 60;

  if (include_hours === false && hours > 0) {
    remaining_minutes += hours * 60;
  }

  if (return_as_zero_padded_strings) {
    remaining_minutes = zeroPad(remaining_minutes);
    remaining_seconds = zeroPad(remaining_seconds);
  }
  else {
    return [hours, remaining_minutes, remaining_seconds];
  }

  let result = [remaining_minutes, remaining_seconds];

  if (include_hours) {
    result.prepend(hours);
  }

  return result;
}

export const secondsToMinutesSeconds = function (seconds, return_as_zero_padded_strings) {
  return secondsToHoursMinutesSeconds(seconds, return_as_zero_padded_strings, false);
}

export const adjustSecondsByUnit = function (existing_seconds, time_unit, new_value) {

  var time_array = secondsToHoursMinutesSeconds(existing_seconds);

  // Adjust the value.
  if (time_unit == 'hours') {
    time_array[0] = parseInt(new_value);
  }
  else if (time_unit == 'minutes') {
    time_array[1] = parseInt(new_value);
  }
  else if (time_unit == 'seconds') {
    time_array[2] = parseInt(new_value);
  }

  return (time_array[0] * 3600) + (time_array[1] * 60) + time_array[2];
}

export const metersPerSecondAsSecondsPerKilometer = function (meters_per_second) {
  if (meters_per_second == 0 || meters_per_second == null) {
    return null;
  }

  let seconds_per_km = (1 / meters_per_second) * 1000.0;
  return seconds_per_km;
}

export const metersPerSecondAsKPH = function(meters_per_second) {
  const meters_per_hour = meters_per_second * 3600;
  const kilometers_per_hour = meters_per_hour / 1000;
  return kilometers_per_hour;
}

export const metersPerSecondAsSecondsPerHundredMeters = function (meters_per_second) {

  if (meters_per_second == 0 || meters_per_second == null) {
    return null;
  }

  let seconds_per_hundred_meters = (1 / meters_per_second) * 100.0;
  return seconds_per_hundred_meters;
}

export const secondsPerKilometerAsMetersPerSecond = function (seconds_per_km) {
  if (seconds_per_km == 0 || seconds_per_km == null) {
    return null;
  }

  return 1 / (seconds_per_km / 1000);
}

export const formatDistance = function (distance, decimal_places, show_plus) {
  return decimalPlaces(distance, decimal_places, 'zero', true, false, show_plus);
}

export const metersPerSecondAsSecondsPerMile = function (meters_per_second) {
  if (meters_per_second == 0 || meters_per_second == null) {
    return null;
  }

  let miles = metersToMiles(meters_per_second);
  return 1 / miles;
}

export const secondsPerMileAsMetersPerSecond = function (seconds_per_mile) {
  if (seconds_per_mile == 0 || seconds_per_mile == null) {
    return null;
  }

  let miles_per_second = 1 / seconds_per_mile;
  return milesToMeters(miles_per_second);
}

export const kilometersToMiles = function (kilometers) {
  return metersToMiles(kilometers * 1000);
}

export const metersToMiles = function (meters) {
  if (!meters) {
    return null;
  }
  return meters * 0.000621371192;
}

export const yardsToMiles = function (yards) {
  if (!yards) {
    return null;
  }
  return yards / 1760;
}

export const milesToMeters = function (miles) {
  return (miles / 0.621371192) * 1000;
}

export const metersToFeet = function (meters) {
  if (!meters) {
    return null;
  }
  else {
    return meters * 3.2808399;
  }
}

export const meanWeightedByDuration = function (value_duration_pairs) {
  var sum_of_weighted_values = 0;
  var total_duration = 0;
  for (var i = 0; i < value_duration_pairs.length; i++) {
    sum_of_weighted_values += value_duration_pairs[i][0] * value_duration_pairs[i][1];
    total_duration += value_duration_pairs[i][1];
  }

  if (sum_of_weighted_values > 0) {
    return sum_of_weighted_values / total_duration;
  }
  else {
    return null;
  }
}

/**
 * Calculate mean of value based on the duration of each trackpoint.
 *
 * This excludes data where the value is zero or not recorded. The typical
 * example of this is when the athlete stops pedaling and so produces
 * zero watts. We don't include this section in the average. However, some
 * devices do and so there could be differences between what we show as
 * recorded by the device and what athlete/coached saved laps show.
 *
 * When it appears that data is mostly recorded once per second, we also
 * discard any periods where the duration seems longer. This is a sign of
 * bad data.
 *
 * Changes to this function should match up with the equivalent Python
 * function so that the data creates the same values both when saved and
 * when the user clicks on it in the UI.
 */
export const meanWeightedByTrackpointDuration = function (trackpoints, attribute_name) {

  if (trackpoints.length == 0) {
    return null;
  }

  // Tally up durations to try and ignore outlier data. This works out if
  // each record is mostly taken at one second intervals. If it is, we assume
  // any data that does not have a one second interval is outlier data (maybe
  // a bad recording) and discard it.
  let durations_of_one_second = 0
  let previous_trackpoint_datetime = null;
  for (let i = 0; i < trackpoints.length; i++) {
    let trackpoint_datetime = trackpoints[i].datetime;
    let duration = trackpoints[i].datetime - previous_trackpoint_datetime;
    if (previous_trackpoint_datetime && duration == 1000) {
      durations_of_one_second++;
    }
    previous_trackpoint_datetime = trackpoint_datetime;
  }
  let only_count_one_second_intervals = (durations_of_one_second > (trackpoints.length * 0.95)) ? true : false;

  // Loop through the trackpoints and calculate average.
  let sum_of_weighted_values = 0;
  let total_duration = 0;
  previous_trackpoint_datetime = trackpoints[0].datetime;
  for (let i = 0; i < trackpoints.length; i++) {
    let value = trackpoints[i][attribute_name];

    // Calculate the weighting of this value in seconds.
    let duration = trackpoints[i].datetime - previous_trackpoint_datetime;

    // Ignore identified outlier data. Also exclude counting zero values such as
    // when watts are zero.
    if (value > 0 && (!only_count_one_second_intervals || (only_count_one_second_intervals && duration == 1000))) {
      // Add up values and the weight in seconds of those values.
      sum_of_weighted_values += value * duration;
      total_duration += duration;
    }

    // Prepare value so we can work out duration for next iteration.
    previous_trackpoint_datetime = trackpoints[i].datetime;

  }

  if (sum_of_weighted_values > 0) {
    return sum_of_weighted_values / total_duration;
  }
  else {
    return null;
  }
}

/**
 * Round a value to a given number of decimal places.
 *
 * - value: either a float or a string that will parse to a float.
 * - decimal_places: the number of decimal places to round to.
 * - zero_or_null: value to return if a zero or null value is passed.
 * - keep_trailing_zeros: whether to keep trailing zeros after the value has been rounded.
 * - preserve_strings: when a string is passed in, preserve trailing zeros and
 *   decimal points. This is useful when this is used to update the value of
 *   a text box that may be half completed (i.e. the user may have entered
 *   "10." and then "10.0" and finally "10.07". This ensures the first two
 *   values are not trimmed.
 * - show plus: On values greater than zero, show a plus sign if set to true.
 */
export const decimalPlaces = function (value, decimal_places, zero_or_null, keep_trailing_zeros, preserve_strings, show_plus)  {

  // If the value is a string, cast it to a float.
  if (typeof(value) == 'string') {

    if (preserve_strings) {
      return value;
    }

    value = parseFloat(value);
  }

  // If the value is nothing decide whether to return zero, null empty string
  // or the original value.
  if (value == 0 || value == null || isNaN(value)) {
    if (zero_or_null == 'null') {
      return null;
    }
    else if (zero_or_null == 'zero') {
      value = 0;
    }
    else if (zero_or_null == 'empty_string') {
      return '';
    }
    else {
      return value;
    }
  }

  // Sort out the decimal points.
  value = value.toFixed(decimal_places);

  // Get rid of trailing zeros.
  if (!keep_trailing_zeros) {
    value = +value;
  }

  if (show_plus && show_plus === true && parseFloat(value) > 0) {
    value = '+' + value;
  }

  return value;
}
